import { Controller } from "@hotwired/stimulus"

async function analyzeImageSize(url) {
  const img = new Image()
  img.src = url
  await new Promise((resolve) => {
    img.onload = resolve
  })
  return {
    width: img.width,
    height: img.height
  }
}

export default class extends Controller {
  static targets = ["file", "previewTemplate", "previewContainer", "imageCount"]
  static values = {
    maxCount: {
      type: Number,
      default: 1
    }
  }

  connect() {
    console.log("upload-preview connected")
    this.#updateImageCount()
  }

  fileTargetConnected() {
    this.fileTarget.addEventListener("change", this.#preview.bind(this))
  }

  fileTargetDisconnected() {
    this.fileTarget.removeEventListener("change", this.#preview.bind(this))
  }

  async #preview(event) {
    console.log("preview", event)
    const files = event.target.files
    if (this.#imagesCount() + files.length > this.maxCountValue) {
      alert(`最多只能上传${this.maxCountValue}张图片`)
      return
    }
    Array.from(files).forEach(async (file) => {
      if (!this.#isImage(file)) {
        alert('只能上传图片文件')
        return
      }

      const reader = new FileReader()
      reader.onload = async (e) => {
        console.log("file", file)
        console.log("result", e.target.result)
        const preview = this.previewTemplateTarget.content.cloneNode(true).children[0]
        const link = preview.querySelector("a")
        const { width, height } = await analyzeImageSize(e.target.result)
        link.href = e.target.result
        link.dataset.pswpWidth = width
        link.dataset.pswpHeight = height
        preview.querySelector("img").src = e.target.result

        const hiddenInput = document.createElement("input")
        hiddenInput.type = "file"
        hiddenInput.name = this.fileTarget.name
        hiddenInput.files = this.#copyFile(file)
        hiddenInput.dataset.directUploadUrl = this.fileTarget.dataset.directUploadUrl
        hiddenInput.style.display = "none"
        preview.appendChild(hiddenInput)

        const removeButton = preview.querySelector(".remove-button")
        removeButton.addEventListener("click", (event) => {
          event.preventDefault()
          preview.remove()
        }, { once: true })
        this.previewContainerTarget.appendChild(preview)
        this.#updateImageCount()
      }
      reader.readAsDataURL(file)
    })

    event.target.value = null
  }

  #imagesCount() {
    return this.previewContainerTarget.children.length
  }

  #updateImageCount() {
    if (this.hasImageCountTarget) {
      this.imageCountTarget.textContent = `${this.#imagesCount()}/${this.maxCountValue}`
    }
  }

  #isImage(file) {
    return file.type.toLowerCase().startsWith("image/")
  }

  #copyFile(file) {
    const data = new DataTransfer()
    data.items.add(file)
    return data.files
  }
}
